import { useSyncExternalStore } from "react";

const listeners = new Set();
export const orbStore = { state: "idle", level: 0, bump: 0, heart: false, moodUntil: 0, theme: (typeof localStorage !== "undefined" && localStorage.getItem("aurora_orb_theme")) || "aurora" };

const GOOD = /(ottim[aoie]|perfett[aoie]|fantastic[aoi]|congratulazioni|complimenti|buone notizie|buona notizia|ottima notizia|evviva|felice|splendid[aoie]|eccellente|meraviglios[aoie]|bravissim[aoie]|ce l'hai fatta|successo|vittoria|auguri)/i;

// Warm glow for good news; lasts roughly as long as Aurora takes to read the reply.
export function setOrbMoodFromText(text) {
  if (GOOD.test(text || "")) orbStore.moodUntil = performance.now() + 8000 + Math.min(40000, (text || "").length * 55);
}

export function setOrbTheme(t) {
  orbStore.theme = t;
  localStorage.setItem("aurora_orb_theme", t);
}

export function setOrbState(s) {
  if (orbStore.state === s) return;
  orbStore.state = s;
  listeners.forEach((l) => l());
}
export const setOrbLevel = (v) => { orbStore.level = Math.max(0, Math.min(1, v)); };
export const bumpOrb = (v = 0.6) => { orbStore.bump = Math.min(1, orbStore.bump + v); };

export function useOrbState() {
  return useSyncExternalStore(
    (l) => { listeners.add(l); return () => listeners.delete(l); },
    () => orbStore.state
  );
}

export const ORB_LABELS = {
  idle: "AURORA IN STANDBY",
  ascolto: "ASCOLTO IN CORSO",
  elaborazione: "ELABORAZIONE…",
  parlato: "AURORA STA PARLANDO",
};
if (typeof window !== "undefined") window.__auroraOrb = orbStore;
